/* RMK 2026 – filtry w kolekcji, galeria karty produktu, przyklejony pasek „Dodaj do koszyka”. */
(function () {
  function initChips(root) {
    if (root.getAttribute('data-r26-ready')) return;
    root.setAttribute('data-r26-ready', '1');
    var chips = root.querySelectorAll('[data-r26-filter]');
    var groups = root.querySelectorAll('[data-r26-group]');
    if (!chips.length || !groups.length) return;
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-r26-filter');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        groups.forEach(function (g) {
          var names = (g.getAttribute('data-r26-group') || '').split(' ');
          g.hidden = !(f === 'all' || names.indexOf(f) !== -1);
        });
      });
    });
  }

  function initGallery(root) {
    if (root.getAttribute('data-r26-ready')) return;
    root.setAttribute('data-r26-ready', '1');
    var track = root.querySelector('[data-r26-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-r26-slide]');
    var thumbs = root.querySelectorAll('[data-r26-thumb]');
    var dots = root.querySelectorAll('[data-r26-dot]');
    if (slides.length < 2) return;
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = i * track.clientWidth;
      track.style.scrollBehavior = prev;
      setActive(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        setActive(Math.min(slides.length - 1, Math.max(0, i)));
      }, 80);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (e.key === 'ArrowRight' && i < slides.length - 1) { e.preventDefault(); go(i + 1); }
      if (e.key === 'ArrowLeft' && i > 0) { e.preventDefault(); go(i - 1); }
    });
  }

  function initSticky(root) {
    if (root.getAttribute('data-r26-sticky-ready')) return;
    root.setAttribute('data-r26-sticky-ready', '1');
    var bar = root.querySelector('[data-r26-sticky]');
    var main = root.querySelector('[data-r26-main-atc]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var btn = bar.querySelector('button');
    if (btn) btn.addEventListener('click', function () { main.click(); });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }).observe(main);
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-r26-chips]').forEach(initChips);
    s.querySelectorAll('[data-r26-gallery]').forEach(initGallery);
    s.querySelectorAll('[data-r26-pdp]').forEach(initSticky);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
